import {
  TASK_CATEGORY_REQUEST,
  TASK_CATEGORY_MUTATION_REQUEST,
  TASK_CATEGORY_FAILURE,
  FETCH_TASK_CATEGORIES_SUCCESS,
  CREATE_TASK_CATEGORY_SUCCESS,
  UPDATE_TASK_CATEGORY_SUCCESS,
  DELETE_TASK_CATEGORY_SUCCESS,
} from "../action/types";

const initialState = {
  categories: [],
  loading: false,
  mutating: false,
  error: null,
};

const getCategoryId = (category) =>
  String(category?.id || category?._id || "");

const taskManagementCategoriesReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case TASK_CATEGORY_REQUEST:
      return { ...state, loading: true, error: null };
    case TASK_CATEGORY_MUTATION_REQUEST:
      return { ...state, mutating: true, error: null };
    case FETCH_TASK_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: payload?.data ?? (Array.isArray(payload) ? payload : []),
      };
    case CREATE_TASK_CATEGORY_SUCCESS:
      return {
        ...state,
        mutating: false,
        categories: [
          payload,
          ...state.categories.filter(
            (category) => getCategoryId(category) !== getCategoryId(payload),
          ),
        ],
      };
    case UPDATE_TASK_CATEGORY_SUCCESS:
      return {
        ...state,
        mutating: false,
        categories: state.categories.map((category) =>
          getCategoryId(category) === getCategoryId(payload)
            ? payload
            : category,
        ),
      };
    case DELETE_TASK_CATEGORY_SUCCESS:
      return {
        ...state,
        mutating: false,
        categories: state.categories.filter(
          (category) => getCategoryId(category) !== getCategoryId(payload),
        ),
      };
    case TASK_CATEGORY_FAILURE:
      return { ...state, loading: false, mutating: false, error: payload };
    default:
      return state;
  }
};

export default taskManagementCategoriesReducer;
